<template>
  <div id="chart" class="pt-0 pl-0">
    <apexchart
      :class="{ apexChart: isInCarousel }"
      type="donut"
      :options="chartOptions"
      :series="stats.totals"
    ></apexchart>
  </div>
</template>

<script>
import { mapState } from "vuex";
import contractYear from "@/mixins/contractYear";

export default {
  name: "SecondCarouselItem",
  mixins: [contractYear],
  props: {
    isInCarousel: {
      type: Boolean,
      default: true,
    },
    isSplited: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      stats: (state) => state.statsCustomer.statsCustomer,
    }),
  },
  data() {
    // Calcul de l'année contractuelle pour l'initialisation
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth() + 1;
    const day = now.getDate();
    const contractYear = month === 1 && day <= 15 ? year - 1 : year;

    return {
      chartOptions: {
        chart: {
          type: "donut",
        },
        dataLabels: {
          enabled: true,
        },
        labels: ["NON ALLOCATED"],
        colors: [
          "#FFB300",
          "#B66A00",
          "#80BDB8",
          "#0092E2",
          "#22605B",
          "#397D7D",
          "#005C87",
          "#DDD8D9",
          "#858482",
          "#3761C2",
          "#532571",
          "#B6743A",
        ],
        title: {
          text: this.isSplited
            ? ""
            : this.$t("ca-by-sub-franchise", {
                year: contractYear,
              }),
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                show: false,
              },
            },
          },
        ],
        legend: {
          position: "right",
          offsetY: 0,
        },
      },
    };
  },
  watch: {
    stats: {
      handler(newStats) {
        this.chartOptions.labels = newStats.names;
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
.apexChart {
  padding-left: 10px;
  padding-top: 25px;
}
</style>
